import moment from 'moment'
import { useState } from 'react'
import { SetStatusAlertDialog } from '../SetStatusAlertDialog/SetStatusAlertDialog'
import './ActionFieldButton.style.less'

interface Prop {
  className: string
  label: string
  onClicked: (actualDate: any) => any
  data: any
}

function ActionFieldButton(prop: Prop) {
  const { className, onClicked, label, data } = prop
  const [visible, setvisible] = useState(false)
  const [actualDate, setActualDate] = useState(moment)

  return (
    <>
      <div className="action-button-container">
        <div className="ant-space ant-space-horizontal ant-space-align-center">
          <div className="ant-space-item">
            <button
              type="button"
              className={`ant-btn ant-btn-round ${className}`}
              onClick={() => {
                if (data.type === 'percentage_progress_type') {
                  onClicked(actualDate)
                } else {
                  setvisible(true)
                }
              }}
            >
              <span>{label}</span>
            </button>
          </div>
        </div>
      </div>
      {visible && (
        <SetStatusAlertDialog
          data={data}
          visible={visible}
          onCancel={() => {
            setvisible(false)
          }}
          actualDate={actualDate}
          setActualDate={setActualDate}
          title={label}
          onSubmit={() => {
            onClicked(actualDate)
            setvisible(false)
          }}
        />
      )}
    </>
  )
}

export default ActionFieldButton
